import { render, staticRenderFns } from "./section-points.vue?vue&type=template&id=30728c40&scoped=true"
import script from "./section-points.vue?vue&type=script&lang=js"
export * from "./section-points.vue?vue&type=script&lang=js"
import style0 from "./section-points.vue?vue&type=style&index=0&id=30728c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30728c40",
  null
  
)

export default component.exports